import * as types from './mutation-types'

export default {
  [types.SET_USER_DATA](state, user) {
    state.user = user
  },
}
